import { useResize } from "ecom-teams-apps-core";
import React, { useRef } from "react";
import { ResizerContext } from "./ResizerContext";

const ResizerStore: React.FC = (props) => {
    const windowRef = useRef(document.body);
    const [windowWidth] = useResize(windowRef);

    return (
        <ResizerContext.Provider
            value={{
                windowWidth: windowWidth
            }}
        >
            {props.children}
        </ResizerContext.Provider>
    );
};

export default ResizerStore;
